<template>
  <div v-html="data.html" class="wrapper"></div>
</template>

<script>

  export default {
    name: 'ContentModuleText',
    props: {
      data: {
        type: Object,
        required: true
      }
    }
  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

  @import "~globals";

</style>



// WEBPACK FOOTER //
// src/components/_global/content-module/text.vue